// ======================================================================
// File Name       : ModalConductor
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/ModalAction';

import store from '../../store';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';

import { ModalCondutor } from './ModalConductorConstants';

/**
 * Open, close modal
 */
class ModalConductor extends Component {
  render() {
    const { modalId, message } = this.props;
    const Container = ModalCondutor[modalId];
    return (
      <div>
        {!!modalId &&
          {}.hasOwnProperty.call(ModalCondutor, modalId) &&
          <Container {...this.props} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { modal, message } = state;
  return {
    ...modal,
    message,
  };
};
const mapDispatchToProps = dispatch => ({ hideModal: () => {
  store.dispatch({
    type: HIDE_MESSAGE,
  });
  return dispatch(hideModal());
},
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalConductor);
